import React from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import PropTypes from 'prop-types';

import {
  ClearButton,
  SelectDropDown
} from 'components/common/Elements/Elements';

import { statusPars } from '../../helpers/configurates';
import { createFilterStatus } from 'utils/common';

import classes from './FiltersBlock.module.scss';

const FiltersBlock = ({
  filter,
  setFilter,
  startFilter,
  setStartFilter,
  filters,
  selectLoader,
  resetAllfilters,
  filterButton,
  setVisibleFilterSave,
  setVisibleFilterEdit,
  changeFilter
}) => {
  const { t } = useTranslation(['activity']);

  const numberОfFilters = 4;

  const handleFilter = e => {
    setFilter({ ...filter, [e.target]: e.value, currentPage: 1 });
    setVisibleFilterSave('button');
    if (changeFilter !== 'Default') {
      setVisibleFilterEdit(true);
    }
  };

  return (
    <div className={cn(filterButton ? classes.filters : classes.filters_close)}>
      <SelectDropDown
        options={createFilterStatus(statusPars, filters.status)}
        input={{ value: filter.status, onChange: handleFilter }}
        name={'status'}
        label={t('activity:filters.STATUS')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      <SelectDropDown
        options={filters.updatedByName}
        input={{ value: filter.updatedByName, onChange: handleFilter }}
        name={'updatedByName'}
        label={t('activity:filters.UPDATED_BY')}
        multi
        renderKey={'label'}
        reload
        closeTrigger={{
          trigger: startFilter,
          setTrigger: setStartFilter
        }}
        selectLoader={selectLoader}
      />
      {filters.ownerName && (
        <SelectDropDown
          options={filters.ownerName}
          input={{ value: filter.ownerName, onChange: handleFilter }}
          name={'ownerName'}
          label={t('activity:filters.OWNER')}
          multi
          searchable
          renderKey={'label'}
          reload
          closeTrigger={{
            trigger: startFilter,
            setTrigger: setStartFilter
          }}
          selectLoader={selectLoader}
        />
      )}
      {filters.isTestTenant && (
        <SelectDropDown
          options={
            filters['isTestTenant']
              ? filters['isTestTenant'].map(item =>
                  item === true ? 'True' : 'False'
                )
              : []
          }
          input={{ value: filter.isTestTenant, onChange: handleFilter }}
          name={'isTestTenant'}
          label={t('activity:filters.IS_TEST_TENANT')}
          closeTrigger={{
            trigger: startFilter,
            setTrigger: setStartFilter
          }}
          reload
          selectLoader={selectLoader}
        />
      )}
      {filters.autoAssign && (
        <SelectDropDown
          options={
            filters['autoAssign']
              ? filters['autoAssign'].map(item =>
                  item === true ? 'True' : 'False'
                )
              : []
          }
          input={{ value: filter.autoAssign, onChange: handleFilter }}
          name={'autoAssign'}
          label={t('activity:filters.AUTO_ASSIGN')}
          closeTrigger={{
            trigger: startFilter,
            setTrigger: setStartFilter
          }}
          reload
          selectLoader={selectLoader}
        />
      )}
      <ClearButton
        className={classes.clear}
        onClick={() => resetAllfilters(false, true, false, true)}
        numberОfFilters={numberОfFilters}
      />
    </div>
  );
};

FiltersBlock.propTypes = {
  filters: PropTypes.object,
  filter: PropTypes.object,
  setFilter: PropTypes.func,
  startFilter: PropTypes.bool,
  setStartFilter: PropTypes.func,
  filterButton: PropTypes.bool,
  selectLoader: PropTypes.bool,
  trigerResetDatePicker: PropTypes.bool,
  resetAllfilters: PropTypes.func,
  setVisibleFilterSave: PropTypes.func,
  setVisibleFilterEdit: PropTypes.func,
  changeFilter: PropTypes.string
};

export default FiltersBlock;
